import { ColumnWidthOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Autocomplete,
  Container,
  InputAdornment,
  TextField,
} from "@mui/material";
import {
  Button,
  Checkbox,
  Col,
  Input,
  Layout,
  Radio,
  Row,
  Skeleton,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ImgMediaCard from "../../component/card-visible/card-visible";
import DateRangePicker from "../../component/datapicker/data-ranger-picker";
import ResponsiveDialog from "../../component/dialog/dialog";
import MyComponent from "../../component/input-mask/input-mask";
import SelectedTag from "../../component/select-tag/selecttag";
import availabilityService from "../../service/serviceAvailable";
import customerService from "../../service/serviceCustomer";
import panelService from "../../service/servicePanel";
import serviceService from "../../service/serviceService";
import userService from "../../service/serviceUser";
import { formatCnpjCpf } from "../../utils/formatters";
import PDFGenerator from "../pdfBudget/pdfBudget";
import "./availability.css";

const { Content, Footer } = Layout;

function NewAvailability({ idbudget, onClose }) {
  const navigate = useNavigate();

  const usuario = JSON.parse(localStorage.getItem("user_token")) || {};

  // Função de filtro customizada que limita os resultados para melhor performance
  const filterCustomerOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    
    // Filtrar e limitar a 300 resultados
    const filtered = options.filter((option) => {
      const searchString = `${option.name} ${option.cpfCnpj || ''}`.toLowerCase();
      return searchString.includes(inputValueLower);
    });
    
    return filtered.slice(0, 300);
  };

  // Filtro para serviços, painéis e outros (busca por name)
  const filterGeneralOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    
    const filtered = options.filter((option) => {
      return option.name?.toLowerCase().includes(inputValueLower);
    });
    
    return filtered.slice(0, 300);
  };

  const [service, setService] = useState("");
  const [panel, setPanel] = useState([]);
  const [panelError, setPanelError] = useState("");
  const [loading, setLoading] = useState(false);

  const [listPanel, setListPanel] = useState([]);
  const [listService, setListService] = useState([]);
  const [dtIni, setDtIni] = useState(dayjs(dayjs(), "YYYY-MM-DD"));
  const [dtFim, setDtFim] = useState(dayjs(dayjs(), "YYYY-MM-DD"));

  const [campanha, setCampanha] = useState("");
  const [campanhaError, setCampanhaError] = useState("");

  const [observation, setObservation] = useState("");

  const [idClient, setIdClient] = useState();
  const [idClientError, setIdClientError] = useState();

  const [customer, setCustomer] = useState();
  const [listCustomer, setListCustomer] = useState([]);
  const [servicePanel, setServicePanel] = useState([]);
  const [user, setUser] = useState(usuario);
  const [saller, setSaller] = useState(usuario);
  const [listUser, setListUser] = useState([]);
  const [column, setColumn] = useState("Contato");

  const [days, setDays] = useState(0);
  const [vlService, setVlService] = useState(0);
  const [qtdInsercao, setQtdInsercao] = useState();
  const [qtdInsercaoError, setQtdInsercaoError] = useState();

  const [itensDaVenda, setItensDaVenda] = useState("0,00");
  const [desconto, setDesconto] = useState("0,00");
  const [total, setTotal] = useState("0,00");
  const [idService, setIdService] = useState();
  const [idServiceError, setIdServiceError] = useState();
  const [totalService, setTotalService] = useState(0);

  const [openDialog, setOpenDialog] = useState();
  const [messageDialog, setMessageDialog] = useState();
  const [titleDialog, setTitleDialog] = useState();
  const [statusDialog, setStatusDialog] = useState();

  const [listInserts, setListInserts] = useState([]);

  const [typeCalc, setTypeCalc] = useState("value");
  const [listaIDCustomer, setListaIDCustomer] = useState([]);
  const [listaIDService, setListaIDService] = useState();
  const [listaIDServiceError, setListaIDServiceError] = useState();

  const [ticketMiddle, setTicketMiddle] = useState(0);

  const [isValores, setIsValores] = useState(false);
  const [isPaineis, setIsPaineis] = useState(false);

  const config = true
    ? { style: "currency", currency: "BRL" }
    : { minimumFractionDigits: 2 };

  const { Text } = Typography;

  const style = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    minHeight: "80vh",
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  };

  useEffect(() => {
    (async () => {
      setLoading(true);

      await panelService.listActive(1, 10000).then((item) => {
        var dadoPanel = [];

        if (item && item.data) {
          item.data.forEach((element) => {
            dadoPanel.push(element);
          });
        }

        setListPanel(dadoPanel);
      }).catch(error => {
        console.log('Erro ao carregar painéis:', error);
        setListPanel([]);
      });

      await serviceService.listActive(1, 10000).then((item) => {
        var dadoService = [];
        
        if (item && item.data) {
          item.data.forEach((element) => {
            dadoService.push(element);
          });
        }

        setListService(dadoService);
      }).catch(error => {
        console.log('Erro ao carregar serviços:', error);
        setListService([]);
      });

      var listQtdInserts = [];
      serviceService
        .listQtdInsert()
        .then((item) => {
          if (item) {
            item.forEach((element) => {
              listQtdInserts.push(element);
            });
          }

          setListInserts(listQtdInserts);
        })
        .catch((error) => {
          console.log(error);
        });

      var listCust = [];
      customerService
        .listCustomerActive(1, 10000)
        .then((item) => {
          if (item && item.data) {
            item.data.forEach((element) => {
              listCust.push(element);
            });
          }

          setListCustomer(listCust);
        })
        .catch((error) => {
          console.log('Erro ao carregar clientes:', error);
          setListCustomer([]);
        });

      await userService
        .editUser(usuario.iduser)
        .then((item) => {
          if (item.success && item.data) {
            setUser(item.data);
          } else {
            console.error("Erro ao carregar usuário:", item);
            setUser(usuario); // Fallback para o usuário do localStorage
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar usuário:", error);
          setUser(usuario); // Fallback para o usuário do localStorage
        });

      var listUser = [];
      userService
        .listarUser(1, 500)
        .then((item) => {
          if (item && item.data) {
            item.data.forEach((element) => {
              listUser.push(element);
            });
          }

          setListUser(listUser);
        })
        .catch((error) => {
          console.log('Erro ao carregar usuários:', error);
          setListUser([]);
        });

      if (idbudget) {
        availabilityService
          .findBudget(idbudget)
          .then(async (budget) => {
            const task = budget.tasks;

            setColumn(budget.name);
            setCampanha(task.campanha);
            setIdClient(task.customer);
            setDesconto(task.discount);
            setTypeCalc(task.typecalc);

            setTotal(task.ticket);
            setQtdInsercao(task.qtdinsert);
            setIdService(task.service);
            setDtIni(task.dtini);
            setDtFim(task.dtend);
            setObservation(task.observation);

            var listaIdPanel = [];
            task.panels.forEach((item) => {
              listaIdPanel.push(item.idpanel);
            });

            setPanel(listaIdPanel);

            if (task.customer) {
              customerService
                .editCustomer(task.customer)
                .then((item) => {
                  if (item.success && item.data) {
                    setCustomer(item.data);
                    setListaIDCustomer(item.data);
                  } else {
                    console.error("Erro ao carregar cliente:", item);
                  }
                })
                .catch((error) => {
                  console.error("Erro ao carregar cliente:", error);
                });
            }

            var vlSaleService = 0;

            await serviceService
              .listServiceActive(1, 10000)
              .then((item) => {
                if (item && item.data) {
                  item.data.forEach((element) => {
                    setVlService(element.vlSale);
                    vlSaleService = element.vlSale;
                    setListaIDService(element);
                    setServicePanel(element);
                    setService(element);
                  });
                }
              })
              .catch((error) => {
                console.error("Erro ao carregar serviço:", error);
              });

            if (task.idsaller) {
              userService
                .editUser(task.idsaller)
                .then((item) => {
                  if (item.success && item.data) {
                    setSaller(item.data);
                  } else {
                    console.error("Erro ao carregar vendedor:", item);
                  }
                })
                .catch((error) => {
                  console.error("Erro ao carregar vendedor:", error);
                });
            }

            var ini = moment(task.dtini, "YYYY-MM-DD");
            var end = moment(task.dtend, "YYYY-MM-DD");

            //Calculando a diferença entre as duas datas somando mais 1 para dar o dia cheio
            var diff = dayjs(end).diff(dayjs(ini));
            var diffDays = moment.duration(diff).asDays() + 1;

            setDays(diffDays);

            calculateTotal(task.items, task.discount, task.typecalc);

            setPanelFields(task.items);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally((item) => {
            setLoading(false);
          });
      }

      setLoading(false);
    })();
  }, []);

  async function calculateTicketMiddleFind(item) {
    var totalInsert = 0;

    var ini = moment(dtIni, "YYYY-MM-DD");
    var end = moment(dtFim, "YYYY-MM-DD");

    //Calculando a diferença entre as duas datas somando mais 1 para dar o dia cheio
    var diff = dayjs(end).diff(dayjs(ini));
    var diffDays = moment.duration(diff).asDays() + 1;

    var vlTotal = item.reduce(
      (a, b) => parseFloat(a) + parseFloat(b.vlTotal),
      0
    );

    item.forEach((item, index) => {
      let data = [...panelFields];

      var totalInsertItem =
        parseInt(item.qtdInsert) * parseInt(diffDays ? diffDays : 0);

      data[index]["totalInsert"] = totalInsertItem;
      totalInsert = parseFloat(totalInsert) + parseFloat(totalInsertItem);
    });

    var totalTicket =
      vlTotal === 0 && totalInsert === 0
        ? 0
        : parseFloat(vlTotal) / parseFloat(totalInsert);

    setTicketMiddle(totalTicket);
  }

  const handleDialogClose = () => {
    setOpenDialog(false);
    onClose();
  };

  const calculateDay = (dtStart, dtEnd) => {
    //Calculando a diferença entre as duas datas somando mais 1 para dar o dia cheio
    var diff = dayjs(dtEnd, "DD/MM/YYYY").diff(dayjs(dtStart, "DD/MM/YYYY"));
    var diffDays = moment.duration(diff).asDays() + 1;

    setDays(diffDays);
  };

  const handleChangeDays = (dates, dateStrings) => {
    console.log("From: ", dateStrings[0], ", to: ", dateStrings[1]);

    // setDtInicio(moment(dateStrings[0], 'DD/MM/YYYY').format('YYYY-MM-DD'))
    // setDtFinal(moment(dateStrings[1], 'DD/MM/YYYY').format('YYYY-MM-DD'))

    setDtIni(moment(dateStrings[0], "DD/MM/YYYY").format("YYYY-MM-DD"));
    setDtFim(moment(dateStrings[1], "DD/MM/YYYY").format("YYYY-MM-DD"));

    calculateDay(dateStrings[0], dateStrings[1]);
  };

  const handleChangePanel = (value) => {
    setPanel(value);
  };

  const handleChangeService = (event) => {
    setVlService(event.vlSale);
    setListaIDService(event);
    setListaIDServiceError("");
  };

  const handleChangeQtdService = (index, qtdInsert) => {
    setQtdInsercao(qtdInsert);
  };

  const totalComDesconto = (desconto, type) => {
    var totalCampanha = panelFields.reduce(
      (a, b) => parseFloat(a) + parseFloat(b.vlTotal),
      0
    );

    var totalGeral = totalCampanha;

    if (type == "percent") {
      totalGeral =
        totalGeral - (parseFloat(totalGeral) * parseFloat(desconto)) / 100;
    } else if (type == "value") {
      totalGeral = totalGeral - parseFloat(desconto);
    }

    setTotal(totalGeral);
  };

  const calculateDiscount = (total, discount, isChecked, typeCalc) => {
    var totalGeral = total;

    if (typeCalc == "percent") {
      totalGeral =
        totalGeral - (parseFloat(totalGeral) * parseFloat(discount)) / 100;
    } else if (typeCalc == "value") {
      totalGeral = totalGeral - parseFloat(discount);
    }

    return totalGeral;
  };

  const calculateChecked = (isChecked, vlService) => {
    var totalGeral = 0;
    var valorCalc = 0;

    if (isChecked) {
      valorCalc =
        parseFloat(vlService || 0) *
        parseInt(qtdInsercao || 0) *
        parseInt(days || 0);
      totalGeral = parseFloat(total || 0) + valorCalc;
    } else {
      valorCalc =
        parseFloat(vlService || 0) *
        parseInt(qtdInsercao || 0) *
        parseInt(days || 0);
      totalGeral = parseFloat(total || 0) - valorCalc;
    }

    calculateDiscount(totalGeral, desconto, isChecked);

    setTotal(totalGeral);
  };

  const calculateTotal = async (item, discount, typeCalc) => {
    var totalCampanha = item.reduce(
      (a, b) => parseFloat(a) + parseFloat(b.vlTotal),
      0
    );
    setItensDaVenda(totalCampanha);
    setTotalService(totalCampanha);

    var totalComDescontoGeral = calculateDiscount(
      totalCampanha,
      discount,
      true,
      typeCalc
    );

    setTotal(totalComDescontoGeral);

    await calculateTicketMiddle(totalComDescontoGeral, item);
  };

  const handleFind = async () => {
    try {
      setLoading(true);
      var listPanel = [];

      await availabilityService
        .findItemsByPanel(panel, dtIni, dtFim, qtdInsercao)
        .then(async (item) => {
          item.forEach((disp) => {
            disp.isChecked = true;

            disp.service = listaIDService;

            var ini = moment(dtIni, "YYYY-MM-DD");
            var end = moment(dtFim, "YYYY-MM-DD");

            var diff = dayjs(end).diff(dayjs(ini));
            var diffDays = moment.duration(diff).asDays() + 1;

            var vltotal =
              parseFloat(vlService || 0) *
              parseInt(qtdInsercao || 0) *
              parseInt(diffDays || 0);

            disp.vlTotal = vltotal;

            listPanel.push(disp);
          });

          calculateTotal(listPanel, desconto, typeCalc);

          setPanelFields(listPanel);

          // await calculateTicketMiddle(listPanel);
          // calculateTicketMiddleFind(listPanel);
        })
        .catch((erro) => {
          console.error(erro);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeServicePanel = (e, index) => {
    let data = [...panelFields];

    var ini = moment(dtIni, "YYYY-MM-DD");
    var end = moment(dtFim, "YYYY-MM-DD");

    //Calculando a diferença entre as duas datas somando mais 1 para dar o dia cheio
    var diff = dayjs(end).diff(dayjs(ini));
    var diffDays = moment.duration(diff).asDays() + 1;

    data[index].service = e;

    var totalItem =
      parseFloat(data[index].service?.vlSale || 0) *
      parseFloat(data[index].qtdInsert || 0) *
      parseInt(diffDays || 0);

    data[index].vlTotal = totalItem;

    setPanelFields(data);
    //calculando o total

    calculateTotalGeral();
  };

  const calculateTotalGeral = async () => {
    var totalCampanha = panelFields.reduce(
      (a, b) => parseFloat(a) + parseFloat(b.vlTotal),
      0
    );

    //Calculando o desconto
    var totalGeral = parseFloat(totalCampanha);
    setItensDaVenda(totalCampanha);

    if (typeCalc == "percent") {
      totalGeral =
        totalGeral - (parseFloat(totalGeral) * parseFloat(desconto)) / 100;
    } else if (typeCalc == "value") {
      totalGeral = totalGeral - parseFloat(desconto);
    }

    setTotal(totalGeral);

    await calculateTicketMiddle(totalGeral, undefined);
  };

  async function calculateTicketMiddle(vlTotal, listItem) {
    var totalInsert = 0;

    if (listItem != undefined) {
      listItem.forEach((item, index) => {
        let data = [...listItem];

        var ini = moment(item.dtStart, "YYYY-MM-DD");
        var end = moment(item.dtEnd, "YYYY-MM-DD");

        //Calculando a diferença entre as duas datas somando mais 1 para dar o dia cheio
        var diff = dayjs(end).diff(dayjs(ini));
        var diffDays = moment.duration(diff).asDays() + 1;

        var totalInsertItem =
          parseInt(item.qtdInsert) * parseInt(diffDays ? diffDays : 0);

        data[index]["totalInsert"] = totalInsertItem;
        totalInsert = parseFloat(totalInsert) + parseFloat(totalInsertItem);
      });
    } else {
      panelFields.forEach((item, index) => {
        let data = [...panelFields];

        var ini = moment(dtIni, "YYYY-MM-DD");
        var end = moment(dtFim, "YYYY-MM-DD");

        //Calculando a diferença entre as duas datas somando mais 1 para dar o dia cheio
        var diff = dayjs(end).diff(dayjs(ini));
        var diffDays = moment.duration(diff).asDays() + 1;

        var totalInsertItem =
          parseInt(item.qtdInsert) * parseInt(diffDays ? diffDays : 0);

        data[index]["totalInsert"] = totalInsertItem;
        totalInsert = parseFloat(totalInsert) + parseFloat(totalInsertItem);
      });
    }

    var totalTicket =
      vlTotal === 0 && totalInsert === 0
        ? 0
        : parseFloat(vlTotal) / parseFloat(totalInsert);

    setTicketMiddle(totalTicket);
  }

  const handleChangeServiceQtdInsert = (qtdInsert, index) => {
    let data = [...panelFields];

    var ini = moment(dtIni, "YYYY-MM-DD");
    var end = moment(dtFim, "YYYY-MM-DD");

    //Calculando a diferença entre as duas datas somando mais 1 para dar o dia cheio
    var diff = dayjs(end).diff(dayjs(ini));
    var diffDays = moment.duration(diff).asDays() + 1;

    var totalInsertItem =
      parseInt(qtdInsert) * parseInt(diffDays ? diffDays : 0);

    data[index].qtdInsert = qtdInsert;
    data[index].totalInsert = totalInsertItem;

    var totalItem =
      parseFloat(data[index].service?.vlSale || 0) *
      parseFloat(data[index].qtdInsert || 0) *
      parseInt(diffDays || 0);

    data[index].vlTotal = totalItem;

    setPanelFields(data);

    calculateTotalGeral();
  };

  const onChangeCheckbox = (event, index, item) => {
    let data = [...panelFields];

    data[index]["isChecked"] = event;

    setPanelFields(data);

    calculateChecked(event, vlService);
  };

  /** 
   * @function prepareData
   * @description Prepara os dados para a criação da venda
   * @returns {Object} - Objeto com os dados preparados
   */
  const prepareData = () => {
    const data = [...panelFields];

    var list = [];

    data.forEach((item) => {
      list.push({
        panel: item.panel,
        service: item.service,
        vlTotal: item.vlTotal,
        qtdInsert: item.qtdInsert,
        totalInsert: item.totalInsert
      });
    });

    const preparedData = {
      list: list,
      qtd_insercao: qtdInsercao,
      days: days,
      dtIni: moment(dtIni, "YYYY-MM-DD").format("DD/MM/YYYY"),
      dtEnd: moment(dtFim, "YYYY-MM-DD").format("DD/MM/YYYY"),
      service: service,
      discount: desconto == "0,00" ? 0 : desconto,
      customer: customer,
      campanha: campanha,
      idbudget: idbudget,
      saller: saller,
    };

    // Navegar para a próxima tela passando os parâmetros
    navigate("/saleParams/", { state: { preparedData } });

    return list;
  };

  const handleChangeUser = (input, newInput) => {
    if (input) {
      setSaller(input);
    } else {
      // Se limpar, manter o usuário padrão
      setSaller(usuario);
    }
  };

  const handleChangeClient = (input, newInput) => {
    if (input) {
      setIdClient(input.idcustomer);
      setCustomer(input);
      setListaIDCustomer(input);
    } else {
      // Limpar os campos quando o usuário remove a seleção
      setIdClient(null);
      setCustomer(null);
      setListaIDCustomer(null);
      setIdClientError(""); // Limpar erro também
    }
  };

  const editarBuget = async () => {
    try {
      var listPanels = [];
      var listItems = [];

      if (validForm()) {
        panelFields.map((item) => {
          if (item.availability) {
            delete item.availability; // Remove a propriedade availability
          }
          return item; // Retorna o objeto modificado
        });

        panelFields.forEach((item) => {
          listPanels.push(item.panel.idpanel);
          listItems.push(item);
        });

        var pData = {
          idbudget: idbudget,
          items: listItems,
          panels: listPanels,
          qtdinsert: qtdInsercao,
          days: days,
          dtini: dtIni,
          dtend: dtFim,
          service: listaIDService,
          discount: desconto == "0,00" ? 0 : desconto,
          typecalc: typeCalc,
          ticket: total,
          iduser: user.iduser,
          campanha: campanha,
          customer: customer,
          idsaller: saller.iduser,
          ticketMeddle: ticketMiddle,
          observation: observation,
        };

        console.log(pData);

        const response = await availabilityService.editarBuget(pData);

        if (
          response.status === 201 ||
          response.success === true ||
          response.status === 200
        ) {
          setOpenDialog(true);
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog(response.message || "Orçamento editado com sucesso");
        } else {
          console.log(response.message);
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops");
          setMessageDialog(response.message || "Erro ao editar orçamento");
        }
      }
    } catch (error) {
      setOpenDialog(true);
      setStatusDialog("error");
      setTitleDialog("Ops");
      setMessageDialog(error.message || "Erro ao editar orçamento");
    }
  };

  function validForm() {
    let thatsOk = true;

    if (!campanha) {
      setCampanhaError("A Campanha precisa ser preenchido");
      thatsOk = false;
    }
    if (!idClient) {
      setIdClientError("O Cliente precisa ser preenchido");
      thatsOk = false;
    }
    if (!panel) {
      setPanelError("O Painel precisa ser preenchido");
      thatsOk = false;
    }
    if (!listaIDService) {
      setListaIDServiceError("O Serviço precisa ser preenchido");
      thatsOk = false;
    }
    if (!qtdInsercao) {
      setQtdInsercaoError("A Qtd inserção precisa ser preenchida");
    }

    return thatsOk;
  }

  const createBuget = async () => {
    try {
      let data = [...panelFields];

      if (validForm()) {
        data.map((item) => {
          if (item.availability) {
            delete item.availability; // Remove a propriedade availability
          }
          return item; // Retorna o objeto modificado
        });

        var listPanels = [];
        var listItems = [];

        data.forEach((item) => {
          listPanels.push(item.panel.idpanel);
          listItems.push(item);
        });

        // Validação do iduser
        const userId =
          user && user.iduser
            ? user.iduser
            : usuario && usuario.iduser
              ? usuario.iduser
              : null;

        if (!userId || userId === 0) {
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Erro");
          setMessageDialog(
            "ID do usuário inválido. Por favor, tente fazer login novamente."
          );
          return;
        }

        var pData = {
          items: listItems,
          panels: listPanels,
          qtdinsert: qtdInsercao,
          days: days,
          dtini: dtIni,
          dtend: dtFim,
          service: listaIDService,
          discount: desconto == "0,00" ? 0 : desconto,
          typecalc: typeCalc,
          ticket: total,
          iduser: userId,
          campanha: campanha,
          customer: customer,
          idsaller: saller.iduser,
          ticketMeddle: ticketMiddle,
          observation: observation,
        };

        console.log(pData);

        const response = await availabilityService.createBuget(pData);

        if (
          response.status === 200 ||
          response.success === true ||
          response.status === 201
        ) {
          setOpenDialog(true);
          setStatusDialog("success");
          setTitleDialog("Muito bem!");
          setMessageDialog(response.message || "Orçamento criado com sucesso");
        } else {
          console.log(response.message);
          setOpenDialog(true);
          setStatusDialog("error");
          setTitleDialog("Ops");
          setMessageDialog(response.message || "Erro ao criar orçamento");
        }
      }
    } catch (error) {
      setOpenDialog(true);
      setStatusDialog("error");
      setTitleDialog("Ops");
      setMessageDialog(error.message || "Erro ao criar orçamento");
    }
  };

  const [panelFields, setPanelFields] = useState([
    {
      idItem: 0,
      qtdService: 0,
      dtStart: "",
      dtEnd: "",
      vlUnit: 0,
      idpanel: 0,
      idservice: 0,
      vlTotal: 0,
      totalInsert: 0,
      qtdInsert: "0",
      vlLiqPercMed: 0,
      percentLiquid: 0,
      vlTotalPercMed: 0,
      percentMedio: 0,
      isChecked: true,
      period: [],
      panel: {
        idpanel: 0,
        name: "",
        type: "",
        dtinsert: "",
        dtupdate: null,
        valid: true,
        address: {
          idAddress: 0,
          address: "",
          number: 0,
          neighborhood: "",
          city: "",
          complement: "N",
          state: "",
          country: "",
          cep: "",
        },
        availability: [],
      },
      service: {
        idservice: 0,
        name: "",
        type: "",
        qtdInsert: 0,
        vlSale: 0,
        user: "",
        codExterno: "",
        isActive: false,
        dtinsert: "",
        dtupdate: "",
        isIntegrate: false,
      },
    },
  ]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleIsTrueValores = (e) => {
    console.log(e.target.checked);
    setIsValores(e.target.checked);
  };

  const handleIsTruePaineis = (e) => {
    console.log(e.target.checked);
    setIsPaineis(e.target.checked);
  };

  return (
    <>
      <Container maxWidth="lx" sx={{ height: "100vh" }}>
        {/* <DrawerPrincipal divOpen={ */}
        <div>
          <div>
            {/* {
                    idbudget ? 
                    ""
                    :
                    <div className="row mb-1">
                            <CustomizedBreadcrumbs title1={"Home"} link1={"/"} 
                                    title2={"Orçamento"} link2={"#"} 
                                    title3={""} link3={"#"}/>
                    </div>
                } */}
            <div style={style}>
              <ResponsiveDialog
                open={openDialog}
                handleClose={handleDialogClose}
                title={titleDialog}
                message={messageDialog}
                status={statusDialog}
              />

              <Layout style={{ background: "#FFF" }}>
                <Layout style={{ background: "#FFF" }}>
                  {/* <Header
                                        style={{
                                            padding: 0,
                                            // background: colorBgContainer,
                                        }}
                                    /> */}
                  <Content
                  // style={{
                  //     margin: '24px 16px 0',
                  // }}
                  >
                    <div
                      style={{
                        // padding: 24,
                        minHeight: 360,
                        // background: colorBgContainer,
                        // borderRadius: borderRadiusLG,
                      }}
                    >
                      <Row gutter={[16, 16]}>
                        <Col span={8}>
                          <Autocomplete
                            size="small"
                            id="combo-box-demo"
                            value={saller && saller}
                            sx={{ width: "100%" }}
                            getOptionLabel={(listUser) =>
                              listUser ? `${listUser.name}` : ""
                            }
                            options={listUser}
                            filterOptions={filterGeneralOptions}
                            isOptionEqualToValue={(option, value) =>
                              option.name === value.name
                            }
                            onChange={(event, newValue) => {
                              if (newValue) {
                                handleChangeUser(newValue);
                              }
                            }}
                            noOptionsText={
                              "Nenhum Usuário com esse nome foi encontrando"
                            }
                            renderOption={(props, option) => {
                              if (!option) return null;
                              return (
                                <li
                                  {...props}
                                  key={option.iduser}
                                  style={{
                                    display: "block",
                                    padding: "8px 16px",
                                    textAlign: "left",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "16px",
                                    }}
                                  >
                                    {option.name}
                                  </div>
                                  {option.email && (
                                    <div
                                      style={{
                                        fontSize: "12px",
                                        color: "#444",
                                        marginTop: "2px",
                                      }}
                                    >
                                      {option.email}
                                    </div>
                                  )}
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Escolher vendedor"
                              />
                            )}
                          />
                        </Col>
                        <Col span={8}>
                          <Tag
                            style={{ fontSize: "15px" }}
                            icon={<ColumnWidthOutlined />}
                            color={
                              column == "❌ Recusada" ? "#af0303fd" : "#55acee"
                            }
                          >
                            {column}
                          </Tag>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                        <Col span={8}>
                          <TextField
                            label="Campanha"
                            fullWidth
                            id="campanha"
                            size="small"
                            value={campanha && campanha}
                            onChange={(e) => {
                              setCampanha(e.target.value);
                              setCampanhaError("");
                            }}
                            helperText={campanhaError ? campanhaError : ""}
                            error={!!campanhaError}
                          />
                        </Col>
                        <Col span={8}>
                          <Autocomplete
                            size="small"
                            id="combo-box-demo"
                            value={listaIDCustomer && listaIDCustomer}
                            sx={{ width: "100%" }}
                            getOptionLabel={(listCustomer) =>
                              `${listCustomer.name
                                ? listCustomer.name
                                : "Escolha o cliente"
                              }`
                            }
                            options={listCustomer}
                            filterOptions={filterCustomerOptions}
                            isOptionEqualToValue={(option, value) =>
                              option.name === value.name
                            }
                            onChange={(event, newValue) => {
                              if (newValue) {
                                handleChangeClient(newValue);
                              }
                            }}
                            noOptionsText={
                              "Nenhum Cliente com esse nome foi encontrado"
                            }
                            renderOption={(props, option) => {
                              if (!option) return null;
                              return (
                                <li
                                  {...props}
                                  key={option.idcustomer}
                                  style={{
                                    display: "block",
                                    padding: "8px 16px",
                                    textAlign: "left",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {option.name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#444",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {formatCnpjCpf(option.cpfCnpj) || "CPF/CNPJ não informado"}
                                  </div>
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                placeholder="Escolher cliente"
                                error={!!idClientError}
                                helperText={!idClient ? idClientError : ""}
                              />
                            )}
                          />
                        </Col>
                        <Col span={8}>
                          <SelectedTag
                            selectedPanels={panel}
                            onChange={handleChangePanel}
                            data={listPanel}
                            panelError={panelError}
                          />
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                        <Col span={6}>
                          <DateRangePicker
                            handleChange={handleChangeDays}
                            size="large"
                            input={[
                              dayjs(dtIni, "YYYY-MM-DD"),
                              dayjs(dtFim, "YYYY-MM-DD"),
                            ]}
                          />
                        </Col>
                        <Col span={6}>
                          <Autocomplete
                            disablePortal
                            size="small"
                            id="combo-box-demo"
                            name="service"
                            value={listaIDService || null}
                            options={listService}
                            filterOptions={filterGeneralOptions}
                            sx={{ width: "100%" }}
                            getOptionLabel={(listService) =>
                              `${listService.name
                                ? listService.name
                                : "Escolha o cliente"
                              }`
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.name === value.name
                            }
                            onChange={(event, newValue) => {
                              if (newValue) {
                                handleChangeService(newValue);
                              }
                            }}
                            noOptionsText={
                              "Nenhum inserção cadastrada no momento com esse valor"
                            }
                            renderOption={(props, option) => {
                              if (!option) return null;
                              return (
                                <li
                                  {...props}
                                  key={option.idservice}
                                  style={{
                                    display: "block",
                                    padding: "8px 16px",
                                    textAlign: "left",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "16px",
                                    }}
                                  >
                                    {option.name}
                                  </div>
                                </li>
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Serviço"
                                error={!!listaIDServiceError}
                                helperText={
                                  !idService ? listaIDServiceError : ""
                                }
                              />
                            )}
                          />
                        </Col>
                        <Col span={6}>
                          <Autocomplete
                            disablePortal
                            size="small"
                            id="combo-box-demo"
                            name="qtdInsert"
                            value={qtdInsercao || null}
                            options={listInserts}
                            sx={{ width: "100%" }}
                            getOptionLabel={(option) => {
                              // O mui espera objetos no autocomplete, por isso convertemos para string
                              // Se option é um número, converte para string
                              if (typeof option === "number") {
                                return String(option);
                              }
                              // Se option é um objeto, tenta extrair o valor
                              if (
                                typeof option === "object" &&
                                option !== null
                              ) {
                                return String(
                                  option.value || option.name || option
                                );
                              }
                              // Se option é string, retorna diretamente
                              return String(option || "");
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option === value
                            }
                            onChange={(event, newValue) => {
                              handleChangeQtdService(0, newValue);
                            }}
                            noOptionsText={
                              "Nenhum inserção cadastrada no momento com esse valor"
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Qtd inserção"
                                error={!!qtdInsercaoError}
                                helperText={
                                  !qtdInsercao ? qtdInsercaoError : ""
                                }
                              />
                            )}
                          />
                        </Col>
                        <Col span={6}>
                          <Button
                            type="primary"
                            size="large"
                            onClick={handleFind}
                          >
                            Pesquisar
                          </Button>
                        </Col>
                      </Row>
                      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
                        <Col span={24}>
                          <TextField
                            label="Observação"
                            fullWidth
                            id="observacao"
                            size="small"
                            value={observation && observation}
                            onChange={(e) => {
                              setObservation(e.target.value);
                            }}
                          />
                        </Col>
                      </Row>

                      <Row gutter={16} style={{ marginTop: 24 }}>
                        {loading ? (
                          <Skeleton />
                        ) : panelFields.length > 0 ? (
                          panelFields.map((item, index) => {
                            if (item.panel.idpanel) {
                              return (
                                <>
                                  <Col key={item.panel.idpanel}>
                                    <ImgMediaCard
                                      item={item}
                                      isChecked={item.isChecked}
                                      days={days}
                                      vlService={totalService}
                                      service={servicePanel}
                                      onChange={(e) => {
                                        onChangeCheckbox(e, index, item);
                                      }}
                                      handleChangeService={(e) => {
                                        handleChangeServicePanel(e, index);
                                      }}
                                      handleChangeQtdInsert={(e) => {
                                        handleChangeServiceQtdInsert(e, index);
                                      }}
                                      qtdInsercao={qtdInsercao}
                                    />
                                  </Col>
                                </>
                              );
                            }
                          })
                        ) : (
                          <Text>Ainda não há resultado de paineis</Text>
                        )}
                      </Row>
                    </div>
                  </Content>
                  <Footer
                    style={{
                      textAlign: "center",
                      marginTop: 24,
                    }}
                  >
                    <Row gutter={[16, 16]}>
                      <Col span={3}>
                        <Radio.Group
                          value={typeCalc}
                          onChange={(e) => {
                            setTypeCalc(e.target.value);
                            totalComDesconto(desconto, e.target.value);
                          }}
                          buttonStyle="solid"
                        >
                          <Radio.Button value="percent">%</Radio.Button>
                          <Radio.Button value="value">R$</Radio.Button>
                        </Radio.Group>
                      </Col>
                      <Col span={4}>
                        {typeCalc == "value" ? (
                          <MyComponent
                            handleInput={(e) => {
                              setDesconto(e);
                              totalComDesconto(e, typeCalc);
                            }}
                            value={desconto && desconto}
                            labelInput="Desconto"
                          />
                        ) : (
                          <Input
                            label="Desconto"
                            id="Desconto"
                            title="0,00"
                            size="small"
                            value={desconto && desconto}
                            onChange={(e) => {
                              setDesconto(e.target.value);
                              totalComDesconto(e.target.value, typeCalc);
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  %
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      </Col>
                      <Col span={4}></Col>
                      <Col
                        span={13}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Text>TKM: </Text>
                        <Text
                          className="highlighted-number"
                          style={{ marginLeft: 8 }}
                        >
                          {ticketMiddle.toLocaleString("pt-BR", config)}
                        </Text>

                        <Text style={{ marginLeft: 16 }}>Itens: </Text>
                        <Text
                          className="highlighted-number"
                          style={{ marginLeft: 8 }}
                        >
                          {itensDaVenda.toLocaleString("pt-BR", config)}
                        </Text>
                        <Text style={{ marginLeft: 16 }}>Desconto: </Text>
                        <Text
                          className="highlighted-number"
                          style={{ marginLeft: 8 }}
                        >
                          {typeCalc == "value"
                            ? desconto.toLocaleString("pt-BR", config)
                            : desconto.toLocaleString("pt-BR", config) + "%"}
                        </Text>
                        <Text style={{ marginLeft: 16 }}>Total: </Text>
                        <Text
                          className="highlighted-number"
                          style={{ marginLeft: 8 }}
                        >
                          {total.toLocaleString("pt-BR", config)}
                        </Text>
                      </Col>
                    </Row>

                    <Row style={{ marginTop: 24 }}>
                      <Col
                        span={24}
                        style={{ display: "flex", alignItems: "right" }}
                      >
                        <Text>Total de Painéis: </Text>
                        <Text
                          className="highlighted-totals-blue"
                          style={{ marginLeft: 8 }}
                        >
                          {
                            panelFields.filter((item) => item.idpanel > 0)
                              .length
                          }
                        </Text>
                        <Text style={{ marginLeft: 16 }}>
                          Itens Selecionados:{" "}
                        </Text>
                        <Text
                          className="highlighted-totals-blue"
                          style={{ marginLeft: 8 }}
                        >
                          {
                            panelFields.filter((item) => item.isChecked == true)
                              .length
                          }
                        </Text>
                        <Text style={{ marginLeft: 16 }}>
                          Painéis Indisponíveis:{" "}
                        </Text>
                        <Text
                          className="highlighted-totals-red"
                          style={{ marginLeft: 8 }}
                        >
                          {
                            panelFields.filter(
                              (item) =>
                                item.idpanel > 0 && item.isActive == false
                            ).length
                          }
                        </Text>
                      </Col>
                    </Row>
                  </Footer>
                  <Footer style={{ background: "#FFF" }}>
                    <Row style={{ marginTop: 24 }}>
                      <Col
                        span={14}
                        style={{ display: "flex", alignItems: "right" }}
                      >
                        <div style={{ display: "flex", gap: "16px" }}>
                          {idbudget ? (
                            <PDFGenerator
                              idbudget={idbudget}
                              isValores={isValores}
                              isPaineis={isPaineis}
                            />
                          ) : (
                            ""
                          )}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: "16px",
                            paddingLeft: "10px",
                          }}
                        >
                          {idbudget ? (
                            <Checkbox
                              checked={isValores}
                              onChange={handleIsTrueValores}
                            >
                              Mostrar Valores
                            </Checkbox>
                          ) : (
                            ""
                          )}
                          {idbudget ? (
                            <Checkbox
                              checked={isPaineis}
                              onChange={handleIsTruePaineis}
                            >
                              Mostrar Paineis{" "}
                            </Checkbox>
                          ) : (
                            ""
                          )}
                        </div>
                      </Col>
                      <Col
                        span={4}
                        style={{ display: "flex", alignItems: "right" }}
                      >
                        {column == "✅ Proposta Aceita" ? (
                          <Tooltip title="Criar venda">
                            <Button
                              onClick={prepareData}
                              type="primary"
                              icon={<PlusOutlined />}
                              size="middle"
                            >
                              Criar venda
                            </Button>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col
                        span={4}
                        style={{ display: "flex", alignItems: "right" }}
                      >
                        <Tooltip title="Criar Orçamento">
                          {idbudget ? (
                            <Button
                              onClick={editarBuget}
                              type="primary"
                              icon={<PlusOutlined />}
                              size="middle"
                            >
                              Salvar
                            </Button>
                          ) : (
                            <Button
                              onClick={createBuget}
                              type="primary"
                              icon={<PlusOutlined />}
                              size="middle"
                            >
                              Salvar
                            </Button>
                          )}
                        </Tooltip>
                      </Col>
                      {/* <Col span={4} style={{ display: 'flex', alignItems: 'right' }}>            
                                                        
                                                </Col> */}
                    </Row>
                  </Footer>
                </Layout>
              </Layout>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
export default NewAvailability;
